import { createReducer, on } from '@ngrx/store';
import { initialModalidadSeleccionState } from './modalidad-seleccion.state';
import * as ModalidadSeleccionActions from './modalidad-seleccion.actions';

export const modalidadSeleccionReducer = createReducer(
  initialModalidadSeleccionState,

  // Load Modalidades Seleccion
  on(ModalidadSeleccionActions.loadModalidadesSeleccion, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(
    ModalidadSeleccionActions.loadModalidadesSeleccionSuccess,
    (state, { modalidadesSeleccion }) => ({
      ...state,
      modalidadesSeleccion,
      loading: false,
      error: null
    })
  ),

  on(ModalidadSeleccionActions.loadModalidadesSeleccionFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Create Modalidad Seleccion
  on(ModalidadSeleccionActions.createModalidadSeleccion, state => ({
    ...state,
    creating: true,
    error: null
  })),

  on(
    ModalidadSeleccionActions.createModalidadSeleccionSuccess,
    (state, { modalidadSeleccion }) => ({
      ...state,
      modalidadesSeleccion: [...state.modalidadesSeleccion, modalidadSeleccion],
      creating: false,
      error: null
    })
  ),

  on(ModalidadSeleccionActions.createModalidadSeleccionFailure, (state, { error }) => ({
    ...state,
    creating: false,
    error
  })),

  // Update Modalidad Seleccion
  on(ModalidadSeleccionActions.updateModalidadSeleccion, state => ({
    ...state,
    updating: true,
    error: null
  })),

  on(
    ModalidadSeleccionActions.updateModalidadSeleccionSuccess,
    (state, { modalidadSeleccion }) => ({
      ...state,
      modalidadesSeleccion: state.modalidadesSeleccion.map(ms =>
        ms.modalidadSelId === modalidadSeleccion.modalidadSelId ? modalidadSeleccion : ms
      ),
      updating: false,
      error: null
    })
  ),

  on(ModalidadSeleccionActions.updateModalidadSeleccionFailure, (state, { error }) => ({
    ...state,
    updating: false,
    error
  })),

  // Delete Modalidad Seleccion
  on(ModalidadSeleccionActions.deleteModalidadSeleccion, state => ({
    ...state,
    deleting: true,
    error: null
  })),

  on(ModalidadSeleccionActions.deleteModalidadSeleccionSuccess, (state, { id }) => ({
    ...state,
    modalidadesSeleccion: state.modalidadesSeleccion.filter(ms => ms.modalidadSelId !== id),
    deleting: false,
    error: null
  })),

  on(ModalidadSeleccionActions.deleteModalidadSeleccionFailure, (state, { error }) => ({
    ...state,
    deleting: false,
    error
  })),

  // Toggle Status
  on(ModalidadSeleccionActions.toggleModalidadSeleccionStatus, state => ({
    ...state,
    updating: true,
    error: null
  })),

  on(
    ModalidadSeleccionActions.toggleModalidadSeleccionStatusSuccess,
    (state, { modalidadSeleccion }) => ({
      ...state,
      modalidadesSeleccion: state.modalidadesSeleccion.map(ms =>
        ms.modalidadSelId === modalidadSeleccion.modalidadSelId ? modalidadSeleccion : ms
      ),
      updating: false,
      error: null
    })
  ),

  on(ModalidadSeleccionActions.toggleModalidadSeleccionStatusFailure, (state, { error }) => ({
    ...state,
    updating: false,
    error
  })),

  // Search
  on(ModalidadSeleccionActions.searchModalidadesSeleccion, (state, { query }) => ({
    ...state,
    searchQuery: query
  })),

  on(ModalidadSeleccionActions.searchModalidadesSeleccionSuccess, (state, { results }) => ({
    ...state,
    searchResults: results
  })),

  on(ModalidadSeleccionActions.clearModalidadSeleccionSearch, state => ({
    ...state,
    searchResults: [],
    searchQuery: ''
  })),

  // Select
  on(ModalidadSeleccionActions.selectModalidadSeleccion, (state, { modalidadSeleccion }) => ({
    ...state,
    selectedModalidadSeleccion: modalidadSeleccion
  })),

  // Clear Error
  on(ModalidadSeleccionActions.clearModalidadSeleccionError, state => ({
    ...state,
    error: null
  }))
);
